import z from "zod";

export const BodyFontOptions = ["Outfit", "Roboto", "EB Garamond"] as const;
export type BodyFont = (typeof BodyFontOptions)[number];

export const MemberSettingsSchema = z.object({
  theme: z.enum(["light", "dark"]).default("light"),
  calendarTypePreference: z.enum(["day", "week"]).default("day"),
  discoModeEnabled: z.boolean().default(true),
  calendarWidth: z.number().default(500),
  allowAnimation: z.boolean().default(true),
  bodyFont: z.enum(BodyFontOptions).default("EB Garamond"),
});

export type MemberSettings = z.infer<typeof MemberSettingsSchema>;
